import React, { useState, useContext, useEffect, useCallback, useRef } from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import Router from './routes'
import apiFetch from './axios/config'

import { AccountContext } from './account';
import { EntityContext } from './entity';
import Loading from './components/loading';



const ProtectedRoutes = () => {
    const [authenticatedUser, setAuthenticatedUser] = useState(false)
    const [token, setToken] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const location = useLocation()

    const { getSession } = useContext(AccountContext)
    const { entity, validateEntity } = useContext(EntityContext)
    
    // Usar refs para estabilizar referências e evitar loops infinitos
    const validateEntityRef = useRef(validateEntity);
    const entityRef = useRef(entity);
    
    // Atualizar refs quando mudarem
    useEffect(() => {
        validateEntityRef.current = validateEntity;
    }, [validateEntity]);
    
    useEffect(() => {
        entityRef.current = entity;
    }, [entity]);

    const getEntity = useCallback(() => {
    
        try {

          // apiFetch.defaults.headers.common.Authorization = `Bearer ${token}`
          const response = apiFetch.get(
            `/user`,  { 'headers': { 'Authorization': `Bearer ${token}` } }
          ).then((response) => {
            const data = response.data;
            
            return data
          })
      
        } catch (error) {
          console.log(error);
        }
    
      }, [token, ])

    useEffect(() => {
        getSession()
            .then(async (data) => {
                setAuthenticatedUser(true)
                // console.log('DATA: ', data.idToken.jwtToken)
                setToken(data.idToken.jwtToken)
                
                // Validar entidade após login usando refs
                const currentEntity = entityRef.current;
                if (currentEntity && typeof currentEntity === 'object' && currentEntity.api_key) {
                    await validateEntityRef.current(data.idToken.jwtToken);
                }
                
                setIsLoading(false)
            })
            .catch(() => {
                // Se não conseguir obter sessão, salva a URL atual para redirecionamento após login
                // Usa window.location para garantir que pega a URL atual mesmo se o componente já montou
                const currentPath = window.location.pathname + window.location.search;
                if (currentPath !== '/login' && currentPath !== '/') {
                    sessionStorage.setItem('redirectAfterLogin', currentPath);
                }
                setAuthenticatedUser(false)
                setIsLoading(false)
            })
    }, [getSession]) // Executar apenas quando getSession mudar (ou na montagem)

    // Mostra loading enquanto verifica autenticação
    if (isLoading) {
        return <Loading />;
    }

    // Se usuário está autenticado mas não tem entidade selecionada, redireciona para seleção de entidade
    // Verifica se entity é uma string vazia (inicial do contexto) ou objeto sem api_key
    if (authenticatedUser) {
        // entity pode ser string vazia '', null, undefined, ou objeto com/sem api_key
        const hasValidEntity = entity && typeof entity === 'object' && entity.api_key;
        const currentPath = location.pathname + location.search;
        
        // Se não tiver entidade válida e não estiver já na página de entidades, salva URL e redireciona
        if (!hasValidEntity && currentPath !== '/dashboard/entities' && currentPath !== '/dashboard/entity') {
            // Se há uma URL salva de redirectAfterLogin, usa ela. Caso contrário, usa o caminho atual
            const savedLoginPath = sessionStorage.getItem('redirectAfterLogin');
            const pathToSave = savedLoginPath || currentPath;
            sessionStorage.setItem('redirectAfterEntitySelection', pathToSave);
            // Remove redirectAfterLogin se existir, pois será usado em redirectAfterEntitySelection
            if (savedLoginPath) {
                sessionStorage.removeItem('redirectAfterLogin');
            }
            return <Navigate to="/dashboard/entities" replace />;
        }
    }

    // Renderiza o Router - ele vai lidar com a navegação interna
    return <Router isAuth={authenticatedUser} />
}

export default ProtectedRoutes